import { render, staticRenderFns } from "./header-categories.vue?vue&type=template&id=79d15d32&scoped=true"
import script from "./header-categories.vue?vue&type=script&lang=js"
export * from "./header-categories.vue?vue&type=script&lang=js"
import style0 from "./header-categories.vue?vue&type=style&index=0&id=79d15d32&prod&scoped=true&lang=scss"
import style1 from "./header-categories.vue?vue&type=style&index=1&id=79d15d32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d15d32",
  null
  
)

export default component.exports